import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { toast } from "react-toastify";
import { Icons } from "../../constants/icon-library";
import { createUser } from "../../features/user/userSlice";
import {
  CREATE_CONSUMER_INITIAL_VALUES,
  createSettingValidationSchema,
} from "../../constants/setting.constants";

function AddUser() {
  const { user } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      await dispatch(
        createUser({
          data: {
            name: values.name.trim(),
            email: values.email.trim(),
            password: values.password,
            orgUuid: user.org,
          },
        })
      ).unwrap();

      toast.success("Setting created successfully");
      resetForm();
      navigate(-1);
    } catch (error) {
      toast.error(error?.message || "Failed to create setting");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="content">
      <h3 className="mb-3 mt-4 d-flex align-items-center">
        <i className={`wb ${Icons("add")} fs-8 me-2 mt-1 align-middle`}></i>
        Add Setting
      </h3>

      <Formik
        initialValues={CREATE_CONSUMER_INITIAL_VALUES}
        validationSchema={createSettingValidationSchema}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting }) => (
          <Form>
            <div className="mb-4">
              <label className="fw-bold mb-2">Name</label>
              <Field
                type="text"
                name="name"
                className="form-control"
                placeholder="Enter setting name"
              />
              <div className="text-danger mt-1">
                <ErrorMessage name="name" />
              </div>
            </div>

            <div className="mb-4">
              <label className="fw-bold mb-2">Email</label>
              <Field
                type="email"
                name="email"
                className="form-control"
                placeholder="Enter setting email"
              />
              <div className="text-danger mt-1">
                <ErrorMessage name="email" />
              </div>
            </div>

            <div className="mb-4">
              <label className="fw-bold mb-2">Password</label>
              <Field
                type="password"
                name="password"
                className="form-control"
                placeholder="Enter password"
              />
              <div className="text-danger mt-1">
                <ErrorMessage name="password" />
              </div>
            </div>

            <div className="d-flex justify-content-between">
              <button
                type="button"
                className="btn btn-outline-danger px-3"
                onClick={() => navigate(-1)}
                disabled={isSubmitting}
              >
                <i
                  className={`wb ${Icons(
                    "cancel"
                  )} fs-8 me-2 mt-2 align-middle`}
                ></i>
                Cancel
              </button>

              <button
                type="submit"
                className="btn btn-primary me-2"
                disabled={isSubmitting}
              >
                <i
                  className={`wb ${Icons("save")} fs-8 me-2 mt-2 align-middle`}
                ></i>
                {isSubmitting ? "Saving..." : "Save Setting"}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default AddUser;
